import LocationSvg from "src/components/svg/LocationSvg";
import { useLocationContext } from "src/lib/contexts/LocationContext";
import classNames from 'classnames';
import styles from './NoLocation.module.css';

//#region [Props]
type NoLocationProps = {
  className?: string;
};
//#endregion

//#region [Component]
export default function NoLocation({ className }: NoLocationProps) {
  const locationContext = useLocationContext();
  return (
    <div
      className={classNames(styles.NoLocation, className)}
      title="Klikk for å velge kinosted"
      onClick={() => locationContext.setShowLocationDialog(true)}
    >
      <LocationSvg className={styles.LocIcon} />
      <div className={styles.NoLocText}>Du må velge kinosted for å se visninger.</div>
    </div>
  );
}
//#endregion

